import { Breadcrumbs } from "@/components/site/Breadcrumbs";
import { TrustBadges } from "@/components/site/TrustBadges";
import { img } from "@/lib/site";
import { cn } from "@/lib/utils";

export const Hero = ({ variant = "page", image, imageAlt, imagePosition = "center", eyebrow, title, subtitle, breadcrumbs, badges = true, children }) => {
  const isHome = variant === "home";
  const { src, srcSet } = img(image);

  return (
    <section
      data-testid="page-hero"
      className={cn(
        "relative isolate overflow-hidden bg-brand-navy text-white",
        isHome ? "lg:min-h-[680px]" : "lg:min-h-[500px]",
      )}
    >
      <div className="relative h-64 sm:h-80 lg:absolute lg:inset-y-0 lg:right-0 lg:h-auto lg:w-[58%]">
        <img
          src={src}
          srcSet={srcSet}
          sizes="(min-width: 1024px) 58vw, 100vw"
          alt={imageAlt}
          width="1600"
          height="1072"
          fetchPriority="high"
          loading="eager"
          decoding="async"
          data-testid="hero-image"
          className="h-full w-full object-cover"
          style={{ objectPosition: imagePosition }}
        />
        <div className="absolute inset-0 bg-brand-blue/10" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/10 to-transparent lg:bg-gradient-to-r lg:via-brand-navy/45" />
      </div>
      <div className="pointer-events-none absolute -left-32 top-1/3 hidden h-96 w-96 rounded-full bg-brand-blue/30 blur-3xl lg:block" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-[minmax(0,1fr)_400px] lg:gap-12">
          <div className={cn("hero-stagger pb-14 pt-1 sm:pb-16 [text-shadow:0_2px_14px_rgba(0,30,60,0.35)]", isHome ? "lg:py-24" : "lg:py-16")}>
            {breadcrumbs ? <Breadcrumbs items={breadcrumbs} light /> : <span />}
            {eyebrow ? (
              <p className="mb-4 inline-flex items-center gap-2 rounded-full bg-brand-yellow px-3.5 py-1 text-xs font-bold uppercase tracking-[0.12em] text-brand-anthracite" data-testid="hero-eyebrow">
                {eyebrow}
              </p>
            ) : <span />}
            <h1
              data-testid="hero-title"
              className={cn(
                "max-w-3xl font-bold leading-[1.1] tracking-tight text-white",
                isHome ? "text-4xl sm:text-5xl lg:text-6xl" : "text-3xl sm:text-4xl lg:text-5xl",
              )}
            >
              {title}
            </h1>
            {subtitle ? (
              <p className="mt-5 max-w-2xl text-base text-white/90 md:text-lg" data-testid="hero-subtitle">{subtitle}</p>
            ) : <span />}
            <div>
              {badges && <TrustBadges />}
              {children}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
